export const EKYCURL = process.env.REACT_APP_EKYC_API;
export const REDIRECTURL = process.env.REACT_APP_REDIRECT_URL;
export const REFERURL = process.env.REACT_APP_REFER_URL;
export const UPLOADSIZELIMIT: number =
  process.env.REACT_APP_UPLOAD_SIZE_LIMIT !== undefined
    ? parseInt(process.env.REACT_APP_UPLOAD_SIZE_LIMIT)
    : 8;
export const UploadSizes = {
  signature: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  pancard: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  incomeproof: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
  bank_proof: {
    pdfSize: 7.5,
    imageSize: 7.5,
  },
};
